import * as React from 'react';
import { MenuConfig, ToolbarConfig } from '@tencent/workbench';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import placeholderSvg from '@tencent/docs-design-resources/icon/desktop/svg/placeholder_outline_light_24.svg';
import horizontalContentSvg from '@tencent/docs-design-resources/icon/desktop/svg/horizontal_content_outline_light_24.svg';
import verticalContentSvg from '@tencent/docs-design-resources/icon/desktop/svg/vertical_content_outline_light_24.svg';
import horizontalTextSvg from '@tencent/docs-design-resources/icon/desktop/svg/horizontal_font_outline_light_24.svg';
import verticalTextSvg from '@tencent/docs-design-resources/icon/desktop/svg/straight_font_outline_light_24.svg';
import imageSvg from '@tencent/docs-design-resources/icon/desktop/svg/image_24.svg';
import tableSvg from '@tencent/docs-design-resources/icon/desktop/svg/table_24.svg';
import { wrapIdForBig } from '@framework/workbench/util/wrap-id-util';
import i18n from '@i18next/i18n';

export const config = {
    id: ActionType.INSERT_PLACEHOLDER,
    tipMsg: i18n.t('插入占位符'),
    icon: placeholderSvg,
    content: i18n.t('占位符'),
};

export const contentConfig = {
    id: ActionType.INSERT_PLACEHOLDER_HORZ_CONTENT,
    icon: horizontalContentSvg,
    content: i18n.t('内容'),
};

export const contentConfigV = {
    id: ActionType.INSERT_PLACEHOLDER_VERT_CONTENT,
    icon: verticalContentSvg,
    content: i18n.t('内容（竖排）'),
};

export const bodyConfig = {
    id: ActionType.INSERT_PLACEHOLDER_HORZ_TEXT,
    icon: horizontalTextSvg,
    content: i18n.t('文字'),
};

export const bodyConfigV = {
    id: ActionType.INSERT_PLACEHOLDER_VERT_TEXT,
    icon: verticalTextSvg,
    content: i18n.t('文字（竖排）'),
};

export const picConfig = {
    id: ActionType.INSERT_PLACEHOLDER_PICTURE,
    icon: imageSvg,
    content: i18n.t('图片'),
};

export const tableConfig = {
    id: ActionType.INSERT_PLACEHOLDER_TABLE,
    icon: tableSvg,
    content: i18n.t('表格'),
};

export const MENU_CONFIGS: MenuConfig[] = [
    {
        name: config.id,
        content: config.content,
        icon: <img src={config.icon} alt={''}/>,
    },
    {
        name: contentConfig.id,
        content: contentConfig.content,
        icon: <img src={contentConfig.icon} alt={''}/>,
    },
    {
        name: contentConfigV.id,
        content: contentConfigV.content,
        icon: <img src={contentConfigV.icon} alt={''}/>,
    },
    {
        name: bodyConfig.id,
        content: bodyConfig.content,
        icon: <img src={bodyConfig.icon} alt={''}/>,
    },
    {
        name: bodyConfigV.id,
        content: bodyConfigV.content,
        icon: <img src={bodyConfigV.icon} alt={''}/>,
    },
    {
        name: picConfig.id,
        content: picConfig.content,
        icon: <img src={picConfig.icon} alt={''}/>,
    },
    {
        name: tableConfig.id,
        content: tableConfig.content,
        icon: <img src={tableConfig.icon} alt={''}/>,
    },
];

export const TOOLBAR_CONFIGS: ToolbarConfig[] = [
    {
        name: config.id,
        tooltip: config.tipMsg,
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
    {
        name: wrapIdForBig(config.id),
        tooltip: config.tipMsg,
        text: i18n.t('占位符'),
        icon: <img src={config.icon} alt={''}/>,
        style: {
            width: 'auto',
        },
    },
];
